import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from "react-helmet-async";

const offerings = [
  {
    oTitle: "Life At Al lbtekar",
    oText: "Life at Al Ibtekar is about passion, purpose, and progress. Our people drive innovation with integrity, work with dedication, and celebrate every success together — creating an environment where excellence thrives.",
    oImg: "/assets/service/life.jpg",
  },
  {
    oTitle: "Shaping Impactful Solutions",
    oText: "At Al Ibtekar, we believe real innovation starts in the field. By understanding the challenges faced by technicians, engineers, and professionals, we design reliable and certified cable management and termination solutions that make a lasting impact.",
    oImg: "/assets/service/shap.jpg",
  },
  {
    oTitle: "Learning That Fuels Growth",
    oText: "We grow by learning every day — from our projects, partners, and customers. Our continuous learning culture ensures we stay ahead of industry standards, bringing smarter, more efficient, and future-ready solutions to every project.",
    oImg: "/assets/service/Learning.jpg",

  },
  {
    oTitle: "Every Voice Matters",
    oText: "We value collaboration and open communication. Every idea, from the workshop floor to the boardroom, is heard and respected — helping us build products and relationships that reflect true teamwork and trust.",
    oImg: "/assets/service/car.jpg",

  },

]
const clients = [
  {
    cTitle: "Flexible Work Schedule",
    cText: "The freedom to work on your own schedule that brings out the best in you",
  },
  {
    cTitle: "International Collaborations",
    cText: "Work with the best minds from across the world, learning and growing together",
  },
  {
    cTitle: "Top of the Line Resources",
    cText: "Work with new-age tech solutions that bring your innovative ideas to fruition",
  },
  {
    cTitle: "Support and Benefits",
    cText: "We’ve got your back in the face of adversities and unforeseen challenges",
  },
]

function Career() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
    <Helmet>
    <title>
        Careers at Al Ibtekar | Jobs & Opportunities in UAE
    </title>

    <meta
        name="description"
        content="Explore career opportunities at Al Ibtekar in the UAE. Join our team and grow with a company delivering innovative cable management, cable termination and electrical solutions."
    />

    <meta
        name="keywords"
        content="Al Ibtekar careers, jobs in UAE, careers in UAE, electrical engineering jobs UAE, sales engineer jobs UAE, electrical jobs Sharjah, instrumentation jobs UAE, cable management jobs UAE, career opportunities UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/career"
    />

    <meta
        property="og:title"
        content="Careers at Al Ibtekar | Jobs & Opportunities in UAE"
    />

    <meta
        property="og:description"
        content="Discover career opportunities at Al Ibtekar and become part of a team focused on innovation, technical excellence and reliable electrical solutions."
    />

    <meta
        property="og:url"
        content="https://saig.me/career"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:site_name"
        content="Al Ibtekar"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Careers at Al Ibtekar | Jobs & Opportunities in UAE"
    />

    <meta
        name="twitter:description"
        content="Join Al Ibtekar and explore career opportunities in electrical, instrumentation, sales and related fields in the UAE."
    />
</Helmet>
      <div className='newbanner-about newbanner-about4'>
        <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>
          <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Career</h6>
          <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Sustainable and profitable cloud landscape
          </p>
        </div>
      </div>
      {/* 
            <div className='career-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] lg:pb-[80px] pb-[40px]'>
                <div className='carrer-card'>
                    <h3>Job Title</h3>
                    <p>Your One-Stop
                        Technical Partner Your One-Stop
                        Technical Partner in Cable Solutions</p>

                    <ul>
                        <li>Qualification</li>
                        <li>Qualification</li>
                        <li>Qualification</li>
                    </ul>
                    <br />
                    <button>Apply</button>


                </div>
                <div className='carrer-card'>
                    <h3>Job Title</h3>
                    <p>Your One-Stop
                        Technical Partner Your One-Stop
                        Technical Partner in Cable Solutions</p>

                    <ul>
                        <li>Qualification</li>
                        <li>Qualification</li>
                        <li>Qualification</li>
                    </ul>
                    <br />
                    <button>Apply</button>


                </div>
                <div className='carrer-card'>
                    <h3>Job Title</h3>
                    <p>Your One-Stop
                        Technical Partner Your One-Stop
                        Technical Partner in Cable Solutions</p>

                    <ul>
                        <li>Qualification</li>
                        <li>Qualification</li>
                        <li>Qualification</li>
                    </ul>
                    <br />
                    <button>Apply</button>


                </div>
                <div className='carrer-card'>
                    <h3>Job Title</h3>
                    <p>Your One-Stop
                        Technical Partner Your One-Stop
                        Technical Partner in Cable Solutions</p>

                    <ul>
                        <li>Qualification</li>
                        <li>Qualification</li>
                        <li>Qualification</li>
                    </ul>
                    <br />
                    <button>Apply</button>


                </div>
                <div className='carrer-card'>
                    <h3>Job Title</h3>
                    <p>Your One-Stop
                        Technical Partner Your One-Stop
                        Technical Partner in Cable Solutions</p>

                    <ul>
                        <li>Qualification</li>
                        <li>Qualification</li>
                        <li>Qualification</li>
                    </ul>
                    <br />
                    <button>Apply</button>


                </div>
                <div className='carrer-card'>
                    <h3>Job Title</h3>
                    <p>Your One-Stop
                        Technical Partner Your One-Stop
                        Technical Partner in Cable Solutions</p>

                    <ul>
                        <li>Qualification</li>
                        <li>Qualification</li>
                        <li>Qualification</li>
                    </ul>
                    <br />
                    <button>Apply</button>


                </div>
            </div> */}

            <section className='pt-[0px]'>
                    <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>
                        <h6 className="text-[28px] font-outfit text-[#000] lg:text-[48px] font-[400] leading-[36px] lg:leading-[50px] pb-[13px]">
                            What We Offer You
                        </h6>
                        <div className="flex gap-[20px] lg:flex-row flex-col items-start justify-between py-10">
                            {/* Left Column (Titles) */}
                            <div className="max-w-[400px] w-full flex flex-col gap-1">
                                {offerings.map((item, idx) => (
                                    <button
                                        key={idx}
                                        onClick={() => setActiveIndex(idx)}
                                        className={`text-left font-[300] border-b border-[#000] py-6 text-[24px] transition-all 
    ${activeIndex === idx
                      ? "text-[#FBB210]"
                      : "text-black text-opacity-50 border-opacity-50 hover:text-[#117DBD] hover:text-opacity-100"
                    }`}
                >
                  {item.oTitle}
                </button>
              ))}
            </div>
            <div className="max-w-[800px] w-full">
              <img
                src={offerings[activeIndex].oImg}
                alt={offerings[activeIndex].oTitle}
                className=" mb-4"
                style={{ height: '280px', width: '100%', objectFit: 'cover', objectPosition: "top", borderRadius: '8px' }}
              />
              {/* <h3 style={{marginTop:'-40px'}} className="text-[28px] lg:text-[30px] font-outfit text-[#FFFFFF]  font-[400] leading-[36px] lg:leading-[50px] mb-2">
                                    {offerings[activeIndex].oTitle}
                                </h3> */}
              <p className="text-[14px] lg:text-[18px] text-[#000]">{offerings[activeIndex].oText}</p>
            </div>
          </div>
          {/* <div className='lg:pt-[70px] pt-[40px] grid lg:grid-cols-3 grid-cols-1 gap-[20px]'>
                            <div className='border rounded-[8px] h-[200px] border-[#471e08] transition-all overflow-hidden duration-300 group hover:border-[#ED6800] relative'>
                                <div className="absolute inset-0 bg-black/50 backdrop-blur-[10px] opacity-0 group-hover:opacity-100 transition-all duration-300"></div>
                                <div className="p-[20px] absolute top-0 left-0 z-20 w-full">
                                    <h6 className="text-[#FFFFFF] font-outfit text-[24px] leading-[30px] font-[700]">Shaping Impactful Solutions</h6>
                                    <p className="pt-[14px] text-[16px] font-outfit font-[200] leading-[24px] text-[#FFFFFF]">From AI-driven platforms to enterprise solutions, Mobikode offers projects that inspire learning, spark creativity, and allow you to contribute to innovations that truly make a difference.</p>
                                </div>
                            </div>
                            <div className='border rounded-[8px] h-[200px] border-[#471e08] transition-all overflow-hidden duration-300 group hover:border-[#ED6800] relative'>
                                <div className="absolute inset-0 bg-black/50 backdrop-blur-[10px] opacity-0 group-hover:opacity-100 transition-all duration-300"></div>
                                <div className="p-[20px] absolute top-0 left-0 z-20 w-full">
                                    <h6 className="text-[#FFFFFF] font-outfit text-[24px] leading-[30px] font-[700]">Learning That Fuels Growth</h6>
                                    <p className="pt-[14px] text-[16px] font-outfit font-[200] leading-[24px] text-[#FFFFFF]">We believe careers grow best with constant learning. At Mobikode, you’ll explore new skills, gain knowledge, and thrive in an environment that inspires innovation and personal growth.</p>
                                </div>
                            </div>
                            <div className='border rounded-[8px] h-[200px] border-[#471e08] transition-all overflow-hidden duration-300 group hover:border-[#ED6800] relative'>
                                <div className="absolute inset-0 bg-black/50 backdrop-blur-[10px] opacity-0 group-hover:opacity-100 transition-all duration-300"></div>
                                <div className="p-[20px] absolute top-0 left-0 z-20 w-full">
                                    <h6 className="text-[#FFFFFF] font-outfit text-[24px] leading-[30px] font-[700]">Every Voice Matters</h6>
                                    <p className="pt-[14px] text-[16px] font-outfit font-[200] leading-[24px] text-[#FFFFFF]">Diversity is our strength, inclusion our culture. At Mobikode, every idea matters, every individual counts, and together we build solutions that inspire change.</p>
                                </div>
                            </div>
                        </div> */}

          {/* <div className='lg:pt-[138px] pt-[80px]'>
                            <div className="grid lg:grid-cols-2 grid-cols-1 items-start lg:gap-0 gap-[30px]">
                                <div className='max-w-[477px] w-full'>
                                    <h6 className="font-[400] font-outfit lg:text-[42px] text-[30px] lg:leading-[48px] leading-[36px] text-[#FFFFFF] pb-[44px]">Perks and Benefits</h6>
                                    <p className="font-[400] font-outfit text-[16px] leading-[20px] text-[#FFFFFF]">We understand that our experts need the right support to be able to bring their best to the job, day after day. We support you in every way possible:</p>
                                </div>
                                <div className="relative">
                                    <div className='sticky top-[100px]'>
                                        <div className="grid gap-[20px]">
                                            <div className='bg-[#232323] rounded-[10px] border border-[#3C3C3C] pt-[27px] lg:px-[35px] px-[20px] flex items-center gap-[50px]'>
                                                <div className='max-w-[448px] w-full'>
                                                    <h6 className="font-[400] font-outfit text-[26px] leading-[32px] text-[#FFFFFF] pb-[20px]">Flexible Work Schedule</h6>
                                                    <p className="font-[400] font-outfit text-[14px] leading-[20px] text-[#FFFFFF] pb-[30px]">The freedom to work on your own schedule that brings out the best in you</p>
                                                    <button className='font-[600] font-outfit text-[14px] leading-[14px] text-[#FFFFFF] pb-[30px]'>Read more</button>
                                                </div>
                                                <button>
                                                    <img
                                                        src="/assets/career/arrow.svg"
                                                        alt=""
                                                        style={{ filter: "brightness(0) invert(1)" }}
                                                    />
                                                </button>
                                            </div>
                                            <div className='bg-[#232323] rounded-[10px] border border-[#3C3C3C] pt-[27px] lg:px-[35px] px-[20px] flex items-center gap-[50px]'>
                                                <div className='max-w-[448px] w-full'>
                                                    <h6 className="font-[400] font-outfit text-[26px] leading-[32px] text-[#FFFFFF] pb-[20px]">International Collaborations</h6>
                                                    <p className="font-[400] font-outfit text-[14px] leading-[20px] text-[#FFFFFF] pb-[30px]">Work with the best minds from across the world, learning and growing together</p>
                                                    <button className='font-[600] font-outfit text-[14px] leading-[14px] text-[#FFFFFF] pb-[30px]'>Read more</button>
                                                </div>
                                                <button>
                                                    <img
                                                        src="/assets/career/arrow.svg"
                                                        alt=""
                                                        style={{ filter: "brightness(0) invert(1)" }}
                                                    />
                                                </button>
                                            </div>
                                            <div className='bg-[#232323] rounded-[10px] border border-[#3C3C3C] pt-[27px] lg:px-[35px] px-[20px] flex items-center gap-[50px]'>
                                                <div className='max-w-[448px] w-full'>
                                                    <h6 className="font-[400] font-outfit text-[26px] leading-[32px] text-[#FFFFFF] pb-[20px]">Top of the Line Resources</h6>
                                                    <p className="font-[400] font-outfit text-[14px] leading-[20px] text-[#FFFFFF] pb-[30px]">Work with new-age tech solutions that bring your innovative ideas to fruition</p>
                                                    <button className='font-[600] font-outfit text-[14px] leading-[14px] text-[#FFFFFF] pb-[30px]'>Read more</button>
                                                </div>
                                                <button>
                                                    <img
                                                        src="/assets/career/arrow.svg"
                                                        alt=""
                                                        style={{ filter: "brightness(0) invert(1)" }}
                                                    />
                                                </button>
                                            </div>
                                            <div className='bg-[#232323] rounded-[10px] border border-[#3C3C3C] pt-[27px] lg:px-[35px] px-[20px] flex items-center gap-[50px]'>
                                                <div className='max-w-[448px] w-full'>
                                                    <h6 className="font-[400] font-outfit text-[26px] leading-[32px] text-[#FFFFFF] pb-[20px]">Support and Benefits</h6>
                                                    <p className="font-[400] font-outfit text-[14px] leading-[20px] text-[#FFFFFF] pb-[30px]">We’ve got your back in the face of adversities and unforeseen challenges</p>
                                                    <button className='font-[600] font-outfit text-[14px] leading-[14px] text-[#FFFFFF] pb-[30px]'>Read more</button>
                                                </div>
                                                <button>
                                                    <img
                                                        src="/assets/career/arrow.svg"
                                                        alt=""
                                                        style={{ filter: "brightness(0) invert(1)" }}
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
          <div className="lg:pt-[100px] pt-[60px]">
            {/* <div className="relative w-full lg:h-[454px] h-[400px]">
                                <img
                                    src="/assets/career/item4.jpg"
                                    className="lg:h-[454px] h-[400px] w-full object-cover"
                                    alt=""
                                />
                                <div
                                    className="absolute inset-0"
                                    style={{
                                        background: "linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))"
                                    }}
                                ></div>
                                <div className='absolute top-[50%] -translate-y-[50%] left-0 w-full z-20 lg:pt-[69px] pt-[30px] lg:pb-[78px] pb-[30px]'>
                                    <h6 className="max-w-[793px] w-full mx-auto text-center font-[400] pb-[30px] font-outfit lg:text-[42px] text-[30px] lg:leading-[48px] leading-[36px] text-[#FFFFFF]">Can't find your dream Job?</h6>
                                    <p className="max-w-[952px] w-full mx-auto font-[300] font-outfit lg:text-[24px] text-[16px] lg:leading-[30px] leading-[24px] text-center text-[#FFFFFF]">We’re continually on the lookout for new talent with different expertise and levels of experience. If you haven’t chanced upon the right fit for your skillset and career goals yet, we suggest you delve deeper.</p>
                                </div>
                            </div> */}

            {/* <h6 className="text-center font-outfit font-[400] lg:text-[42px] text-[30px] lg:leading-[48px] leading-[36px] text-[#FFFFFF] lg:pt-[84px] pt-[40px] pb-[13px]">LATEST CAREERS </h6>
                            <div className='h-[8px] max-w-[260px] w-full mx-auto bg-[#ED6800]' /> */}
                          
                        </div>
                    </div>
                </section>
                 <section className="bg-[#ffffff] pt-[0px] md:pt-[0px] lg:pt-[0px]">
                            <div className="max-w-[1440px] flex flex-col lg:flex-row justify-between items-start mx-auto w-full gap-[40px] lg:px-[50px] px-[20px]">
                                <div className="lg:max-w-[480px] max-w-[100%] w-full text-[#000] lg:sticky lg:top-[150px] self-start">
                                    <h6 data-aos="fade-right" className="text-[28px] lg:text-[48px] font-outfit font-[400] mb-[24px] leading-[40px] lg:leading-[56px]">
                                        Perks and Benefits
                                    </h6>
                                    <p className="font-outfit text-[16px] font-[400] leading-[24px] mb-[20px] md:mb-[36px]">
                                        We understand that our experts need the right support to be able to bring their best to the job, day after day. We support you in every way possible:
                                    </p>
                                </div>
                             <div className="lg:max-w-[600px] max-w-[100%] w-full">
  <div className="grid lg:grid-cols-2 grid-cols-1 gap-[20px]">
    {clients.map((item, index) => (
      <div key={index}>
        <div
          className="nsr group relative rounded-[8px] backdrop-blur-[10px] p-[15px] md:p-[20px] pr-[60px] md:pr-[74px] border transition-all duration-300 transform hover:scale-[1.03] hover:shadow-lg hover:bg-[#FBB210]"
          style={{ boxShadow: "0px 4px 10px 0px #0000000D" }}
        >
          <div className="flex flex-col sm:flex-row gap-[15px] md:gap-[30px] items-start transition-all duration-300">
            <div>
              <h6 className="text-[20px] font-outfit md:text-[24px] lg:text-[26px] font-[500] mb-[15px] md:mb-[25px] text-[#000] group-hover:text-[#fff] transition-colors duration-300">
                {item.cTitle}
              </h6>
              <p className="text-[14px] font-outfit font-[400] leading-[20px] text-[#000] group-hover:text-[#fff] transition-colors duration-300">
                {item.cText}
              </p>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

        </div>
      </section>

      <br />
      <br />

      <div className='LatestCareers'>
        <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>
          <div className='lates-heading'>
            <h3>Latest Careers</h3>
          </div>
       <div className='LatestCareers-cards'>

  {/* <div className='LatestCareers-card'>
    <h3>Cashier</h3>
    <p>Join our dynamic team and manage daily transactions with accuracy and efficiency. We value dedication, attention to detail, and a customer-first attitude.</p>
    <a href="mailto:info@saig.me?subject=Job Application - Cashier">
      <button>
        Apply Now 
        <img
          src="/assets/nav/arrow.svg"
          alt="Trusted cable management and termination solutions provider in the UAE"
          className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 filter invert"
        />
      </button>
    </a>
  </div>

  <div className='LatestCareers-card'>
    <h3>Account Manager</h3>
    <p>Build and nurture client relationships while driving growth and satisfaction. We seek proactive individuals with strong communication and organizational skills.</p>
    <a href="mailto:info@saig.me?subject=Job Application - Account Manager">
      <button>
        Apply Now 
        <img
          src="/assets/nav/arrow.svg"
          alt="Trusted cable management and termination solutions provider in the UAE"
          className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 filter invert"
        />
      </button>
    </a>
  </div> */}
  <div className='LatestCareers-card'>
    <h3>Sales Engineer</h3>
    <p>Young, dynamic candidate around 28 years, with valid driving license and experience in selling electrical & instrumentation products to industrial customers.</p>
    <a href="mailto:info@saig.me?subject=Sales Engineer">
      <button>
        Apply Now 
        <img
          src="/assets/nav/arrow.svg"
          alt="Trusted cable management and termination solutions provider in the UAE"
          className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 filter invert"
        />
      </button>
    </a>
  </div>
  <div className='LatestCareers-card'>
    <h3>Social Media Specialist</h3>
    <p>Create engaging content and manage online presence across platforms. We’re looking for creative minds passionate about digital trends and brand storytelling.</p>
    <a href="mailto:info@saig.me?subject=Job Application - Social Media Specialist">
      <button>
        Apply Now 
        <img
          src="/assets/nav/arrow.svg"
          alt="Trusted cable management and termination solutions provider in the UAE"
          className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 filter invert"
        />
      </button>
    </a>
  </div>

</div>

        </div>

      </div>

    </>
  )
}

export default Career